import { render, staticRenderFns } from "./assessment-mobile.vue?vue&type=template&id=c3d8981c&scoped=true&"
import script from "./assessment-mobile.vue?vue&type=script&lang=ts&"
export * from "./assessment-mobile.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-mobile.vue?vue&type=style&index=0&id=c3d8981c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d8981c",
  null
  
)

export default component.exports